exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr td{border-bottom:0!important}.filters_search{min-width:100px;max-width:100%}.filters_select{min-width:100px;max-width:200px}.filters_button{min-width:50px;max-width:100px}.bordered_up_top{border-top:5px solid #4c4c4c!important}.v-data-table__mobile-row{align-items:flex-start}#examplefile_table>.v-data-table__wrapper>table>tbody>tr.v-data-table__mobile-table-row{border-top:solid;padding-top:15px}#examplefile_table .v-data-table__mobile-table-row{padding-bottom:15px}", ""]);

// exports
